/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SubmitPromoCodeInput = {
  /** Promotion code */
  readonly code: string;
};

export type InvalidPromoCodeFieldsFragment = { readonly message: string; readonly status: number };

export type SubmitPromoCodeMutationVariables = Exact<{
  input: Types.SubmitPromoCodeInput;
}>;

export type SubmitPromoCodeMutation = {
  readonly submitPromoCode:
    | { readonly __typename: 'InvalidPromoCode'; readonly message: string; readonly status: number }
    | { readonly __typename: 'PromoCodeAlreadyApplied' }
    | { readonly __typename: 'SubmitPromoCodeSuccessV2' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const InvalidPromoCodeFieldsFragmentDoc = gql`
  fragment InvalidPromoCodeFields on InvalidPromoCode {
    message
    status
  }
`;
export const SubmitPromoCodeDocument = gql`
  mutation SubmitPromoCode($input: SubmitPromoCodeInput!) {
    submitPromoCode(input: $input) {
      __typename
      ...ValidationErrorFields
      ...InvalidPromoCodeFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
  ${InvalidPromoCodeFieldsFragmentDoc}
`;

export function useSubmitPromoCodeMutation() {
  return Urql.useMutation<SubmitPromoCodeMutation, SubmitPromoCodeMutationVariables>(
    SubmitPromoCodeDocument,
  );
}
